module.exports = __webpack_public_path__ + "static/media/GA-2100FF-8AER_OR01.8825f257.png";